import { AbstractModel } from '../base';
import { IAddress, IAddressData } from './address.types';

export class Address extends AbstractModel implements IAddress {
  readonly id?: number;
  readonly address1: string;
  readonly address2: string;
  readonly address3: string;
  readonly address4: string;
  readonly city: string;
  readonly region: string;
  readonly postal_code: string;
  readonly country: string;

  constructor(data: IAddressData) {
    super();

    const requiredFields: (keyof IAddressData)[] = ['country'];

    this.validate(data, requiredFields);

    if (data.id) {
      this.id = data.id;
    }

    this.address1 = data.address1 ?? '';
    this.address2 = data.address2 ?? '';
    this.address3 = data.address3 ?? '';
    this.address4 = data.address4 ?? '';
    this.city = data.city ?? '';
    this.region = data.region ?? '';
    this.postal_code = data.postal_code ?? '';
    this.country = data.country!;
  }

  toString() {
    const addresses: string[] = [];

    if (this.address1 || this.address2) {
      const firstAddressGroup = [];
      if (this.address1) firstAddressGroup.push(this.address1);
      if (this.address2) firstAddressGroup.push(this.address2);

      addresses.push(firstAddressGroup.join(', '));
    }

    if (this.address3 || this.address4) {
      const secondAddressGroup = [];
      if (this.address3) secondAddressGroup.push(this.address3);
      if (this.address4) secondAddressGroup.push(this.address4);

      addresses.push(secondAddressGroup.join(', '));
    }

    if (this.city || this.region) {
      const cityAddressGroup = [];
      if (this.city) cityAddressGroup.push(this.city);
      if (this.region) cityAddressGroup.push(this.region);

      addresses.push(cityAddressGroup.join(' '));
    }

    if (this.postal_code || this.country) {
      const countryAddressGroup = [];

      if (this.country) countryAddressGroup.push(this.country);
      if (this.postal_code) countryAddressGroup.push(this.postal_code);
      addresses.push(countryAddressGroup.join(' '));
    }

    return addresses.join(', \n');
  }

  /** return address in the format
   * address1,
   * address 2,
   * city, province,
   * Country, Postal Code
   * **/
  toAddressStringFormat(): string {
    const addressParts: string[] = [];

    if (this.address1) addressParts.push(this.address1);
    if (this.address2) addressParts.push(this.address2);
    if (this.address3) addressParts.push(this.address3);
    if (this.address4) addressParts.push(this.address4);

    const cityRegion = [];
    if (this.city) cityRegion.push(this.city);
    if (this.region) cityRegion.push(this.region);

    if (cityRegion.length > 0) addressParts.push(cityRegion.join(', '));

    const countryPostal = [];
    if (this.country) countryPostal.push(this.country);
    if (this.postal_code) countryPostal.push(this.postal_code);

    if (countryPostal.length > 0) addressParts.push(countryPostal.join(', '));

    return addressParts.join(', \n');
  }
}
